/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2020. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';
import { AddOn, ClientAddOn } from '@core/models';
import { Client } from '@truckstop-tms/zuum-lib';

export const load = createAction('[ClientDetails:AddOn] Load', props<{ client: Client }>());
export const loadSuccess = createAction('[ClientDetails:AddOn] Load Success', props<{ addOns: AddOn[] }>());
export const loadFailure = createAction('[ClientDetails:AddOn] Load Failure', props<{ errorMessage: string }>());

export const activateAddon = createAction('[ClientDetails:AddOn] Activate Add On', props<{ addOn: AddOn }>());
export const activateAddonSuccess = createAction(
  '[ClientDetails:AddOn] Activate Add On Success',
  props<{ clientAddOn: ClientAddOn }>()
);
export const activateAddonFailure = createAction(
  '[ClientDetails:AddOn] Activate Add On Failure',
  props<{ errorMessage: string }>()
);

export const deactivateAddon = createAction(
  '[ClientDetails:AddOn] Deactivate Add On',
  props<{ addOn: AddOn; showNotification: boolean }>()
);
export const deactivateAddonSuccess = createAction(
  '[ClientDetails:AddOn] Deactivate Add On Success',
  props<{ clientAddOn: ClientAddOn }>()
);
export const deactivateAddonFailure = createAction(
  '[ClientDetails:AddOn] Deactivate Add On Failure',
  props<{ errorMessage: string }>()
);
